import { ecboClient } from 'lib/axios'

import type {
  ReservationPriceError,
  ReservationPriceResponse,
  ReservationQuoteParams,
} from 'features/space/types/reservation'

const API_RESERVATIONS_PRICE = '/api/web/reservations/price'

/**
 * 合計料金の見積もり (POST /api/web/reservations/price)。
 * リクエストボディは validate と同一形状。
 * accessToken を渡すと has_duplicated_reservations が判定される (未認証は常に false)。
 */
export const fetchReservationPrice = async (
  params: ReservationQuoteParams,
  accessToken?: string
) => {
  try {
    const response = await ecboClient.post<ReservationPriceResponse>(
      API_RESERVATIONS_PRICE,
      params,
      {
        headers: accessToken ? { Authorization: `Token ${accessToken}` } : undefined,
      }
    )

    return {
      isOk: true as const,
      data: response.data,
      errors: null,
    }
  } catch (error) {
    return {
      isOk: false as const,
      data: null,
      errors: (error?.response?.data?.errors ?? null) as ReservationPriceError[] | null,
    }
  }
}
